export enum FormLocationInformationFormValues {
    origin = 'origin',
    loadingPort = 'loadingPort',
    destination = 'destination',
}

export const formLocationInformationInitialValues = {
    [FormLocationInformationFormValues.origin]: '',
    [FormLocationInformationFormValues.loadingPort]: '',
    [FormLocationInformationFormValues.destination]: '',
}